module.exports = __webpack_public_path__ + "static/media/ipad_10_9_inch_air_blue.b5167dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_10_9_inch_air_blue.png
// module id = 2108
// module chunks = 0